import { polyfill } from "../help/polyfill";
import { setting } from "./setting";
import { cr } from "fire-wind-water";

function extend(target: any, src: any) {
  let key: string;
  let deep: any;
  const flatOptions: any = setting.flatOptions || {};
  for (key in src) {
    if (src[key] !== undefined) {
      (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
    }
  }
  if (deep) {
    cr.extend(true, target, deep);
  }
  return target;
}

polyfill().$cz = {
  event(s, ...arg) {
    if (setting[s]) {
      cr.each(setting[s], (d) => {
        d(...arg);
      });
    }
  },
  setup(s, c): any {
    if (c === undefined) {
      return setting[s];
    }
    if (cr.isFunction(c)) {
      if (!setting[s]) {
        setting[s] = [];
      }
      setting[s].push(c);
      return {
        unsubscribe() {
          setting[s] = setting[s].filter((d) => d !== c);
        },
      };
    } else {
      return c ? extend(extend(s, setting), c) : extend(setting, s);
    }
  },
};
